module.exports = __webpack_public_path__ + "img/82800.baad2a71.jpg";